module.exports = __webpack_public_path__ + "img/gallery-4.062f4501.jpg";